/**
 * 現在地を取得するフック
 *
 * マウントしただけでは取得しない。位置情報の許可ダイアログはユーザーの操作を
 * きっかけに出したいので、request() を呼んだときにだけ問い合わせる。
 */

import { useCallback, useState } from 'react'

export type Coords = {
  latitude: number
  longitude: number
}

const OPTIONS: PositionOptions = {
  enableHighAccuracy: false,
  timeout: 10_000,
  // 少し前の値で十分。毎回 GPS を起こすと待たされる
  maximumAge: 60_000,
}

export const useCurrentPosition = () => {
  const [coords, setCoords] = useState<Coords | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  const request = useCallback(async (): Promise<Coords | null> => {
    if (!navigator.geolocation) return null

    setIsLoading(true)
    try {
      const position = await new Promise<GeolocationPosition>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, OPTIONS)
      })
      const next = { latitude: position.coords.latitude, longitude: position.coords.longitude }
      setCoords(next)
      return next
    } catch {
      return null
    } finally {
      setIsLoading(false)
    }
  }, [])

  return { coords, isLoading, request }
}
